<template>
  <div>
    <h2 class="step-name">Client Details</h2>

    <div class="step-section">
      <radio-input
        label="Are you an organic farm"
        field-name="is_organic_client"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
      >
      </radio-input>

      <text-input label="The keyvet(s) for this client" field-name="current_keyvets_list" disabled> </text-input>

      <number-input label="Total Farm Area (Ha)" field-name="total_farm_area_ha"> </number-input>

      <div class="row">
        <div class="col-md-6 col-md-offset-3">
          <div>
            <h3><u> Sections to be shown </u></h3>

            <animal-type-section animal-type="sheep"></animal-type-section>

            <animal-type-section animal-type="beef"></animal-type-section>

            <animal-type-section animal-type="deer"></animal-type-section>

            <animal-type-section animal-type="dairy_support"></animal-type-section>

            <div class="panel panel-default text-left">
              <div class="panel-heading">
                <check-box label="Lifestyle/Other" field-name="is_lifestyle" style="margin-bottom: 0"> </check-box>
              </div>
            </div>
            <div class="panel panel-default text-left">
              <div class="panel-heading">
                <check-box label="Dogs" field-name="is_dogs" style="margin-bottom: 0"> </check-box>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import baseComponent from '@/mixins/base_consult_component_v2'
import AnimalTypeSection from '@/components/general_farm_consult/_/AnimalTypeSection'

export default {
  name: 'ClientDetails',
  mixins: [baseComponent],
  components: {
    AnimalTypeSection,
  },
  methods: {
    hasAnimals: function (animalType) {
      return Object.keys(this.animals(animalType, true)).length > 0
    },
  },
  computed: {
    ...mapGetters('currentConsult', ['animals', 'newAnimals']),
  },
}
</script>
